import { gettingList, fetchList, resetList, updateList, searchList } from '../utils.js'

export default {
  getList: ({ state, dispatch }) => gettingList(state, dispatch),

  fetch: ({ commit }) => fetchList('events', commit),

  reset: ({ commit }) => resetList(commit),

  update: ({ commit, state }, value) =>  updateList(commit, state, value, 'events'),

  search: ({ commit, state }, value) => searchList(commit, state, value, 'events')
}
